module.exports = require('./dist/server/lib/GlobalMarkupOptions');
